/**
 * Test IDs for MoveHistory component elements
 * This library provides a centralized way to generate test IDs for move history elements
 * to ensure consistency between the component and tests.
 */
export const moveHistoryTestIds = {
  /**
   * Generate test ID for a move history entry based on entry ID
   * @param entryId - The unique entry ID
   * @returns Test ID string (e.g., 'move-history-entry-abc123')
   */
  getMoveEntryTestId: (entryId: string): string => {
    return `move-history-entry-${entryId}`;
  },

  /**
   * Test ID for the move history container
   */
  moveHistoryContainer: 'move-history-container',
} as const




